import api from '@/services/api'
import { useAuthStore } from '@/store/authStore'

export type TenantSynonym = {
  id: string
  tenantId: string
  term: string
  synonyms: string[]
  source: string
  approved: boolean
  usageCount: number
  createdAt: string
  updatedAt: string
}

export type SynonymsAIStatus = {
  status: 'not_generated' | 'pending' | 'active'
  generatedCount: number
  pendingApprovalCount: number
  approvedCount: number
}

export type AIGenerateInput = {
  businessType?: string
  targetAudience: string
  topProducts: string
  localSlang?: string
  country?: string
}

export async function getSynonymsAIStatus(): Promise<SynonymsAIStatus> {
  const tenantId = useAuthStore.getState().tenantId
  if (!tenantId) throw new Error('Missing tenantId')
  const res = await api.get(`/api/tenants/${tenantId}/synonyms/ai/status`)
  return res.data.data as SynonymsAIStatus
}

export async function generateSynonymsAI(payload: AIGenerateInput): Promise<unknown> {
  const tenantId = useAuthStore.getState().tenantId
  if (!tenantId) throw new Error('Missing tenantId')
  const res = await api.post(`/api/tenants/${tenantId}/synonyms/ai/generate`, payload)
  return res.data.data
}

export async function listSynonyms(params?: { includeUnapproved?: boolean }): Promise<TenantSynonym[]> {
  const tenantId = useAuthStore.getState().tenantId
  if (!tenantId) throw new Error('Missing tenantId')
  const qp = params?.includeUnapproved ? '?includeUnapproved=true' : ''
  const res = await api.get(`/api/tenants/${tenantId}/synonyms${qp}`)
  return res.data.data as TenantSynonym[]
}

export async function approveSynonym(id: string): Promise<TenantSynonym> {
  const tenantId = useAuthStore.getState().tenantId
  if (!tenantId) throw new Error('Missing tenantId')
  const res = await api.post(`/api/tenants/${tenantId}/synonyms/${id}/approve`)
  return res.data.data as TenantSynonym
}

export async function updateSynonym(id: string, payload: { term?: string; synonyms?: string[]; approved?: boolean }): Promise<TenantSynonym> {
  const tenantId = useAuthStore.getState().tenantId
  if (!tenantId) throw new Error('Missing tenantId')
  const res = await api.put(`/api/tenants/${tenantId}/synonyms/${id}`, payload)
  return res.data.data as TenantSynonym
}

export async function deleteSynonym(id: string): Promise<void> {
  const tenantId = useAuthStore.getState().tenantId
  if (!tenantId) throw new Error('Missing tenantId')
  await api.delete(`/api/tenants/${tenantId}/synonyms/${id}`)
}
